import styled from 'styled-components'
import { BodyText } from 'styling/Typography'
import { Box, Flex } from 'styling/GlobalStyles'

export const TwoColumn = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  width: 100%;
  align-items: stretch;
  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`

export const SidePanel = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-height: 280px;
  max-height: calc(100vh - 12rem);
  padding: 1.25rem;
`

export const PanelScroll = styled.div`
  flex: 1;
  min-height: 180px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 2px;
`

export const EmptyState = styled(Flex)`
  flex: 1;
  min-height: 200px;
  justify-content: center;
`

export const ListRow = styled.div`
  padding: 0.75rem 1rem;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme.tableBorder};
  background: ${(p) => p.theme.inputBackground};
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  cursor: pointer;
  transition: outline 0.2s ease;

  &:hover {
    outline: 1px solid ${(p) => p.theme.colorOrange};
  }
`

export const Snippet = styled(BodyText)`
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  flex: 1;
  min-width: 0;
  margin: 0;
`

export const RowDate = styled(BodyText)`
  flex-shrink: 0;
  margin: 0;
  white-space: nowrap;
`

export const DocListRow = styled(Flex)`
  padding: 0.75rem 1rem;
  border-radius: 10px;
  border: 1px solid ${(p) => p.theme.tableBorder};
  background: ${(p) => p.theme.inputBackground};
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;

  &:hover {
    outline: 1px solid ${(p) => p.theme.colorOrange};
  }
`

export const DocumentIconSmall = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  svg {
    width: 28px;
    height: 28px;
  }
`

export const IconAction = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: 1px solid transparent;
  background: transparent;
  color: inherit;
  cursor: pointer;
  padding: 0;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: ${(p) => p.theme.inputBackground};
    border-color: ${(p) => p.theme.colorOrange};
  }
`
